import React, { useEffect, useState } from "react";
import { API_URL, authFetch } from "../../utils/auth";

const DEFAULT_OPTIONS = [
  { value: "automatic", label: "Automatic after 14-day hold" },
  { value: "weekly", label: "Weekly - Wednesdays" },
  { value: "monthly", label: "Monthly - 1st of each month" },
];

export default function PayoutRulesCard({ partner = {}, onUpdated }) {
  const options = partner.commission_payout_schedule_options || DEFAULT_OPTIONS;
  const [schedule, setSchedule] = useState(partner.commission_payout_schedule || "automatic");
  const [saving, setSaving] = useState(false);
  const [message, setMessage] = useState("");

  useEffect(() => {
    setSchedule(partner.commission_payout_schedule || "automatic");
  }, [partner.commission_payout_schedule]);

  async function saveSchedule(nextSchedule) {
    setSchedule(nextSchedule);
    setSaving(true);
    setMessage("");
    try {
      const response = await authFetch(`${API_URL}/partner/profile/`, {
        method: "PATCH",
        headers: { "Content-Type": "application/json" },
        body: JSON.stringify({ commission_payout_schedule: nextSchedule }),
      });
      const data = await response.json();
      if (!response.ok) throw new Error(data.detail || "Unable to update payout schedule.");
      setMessage("Payout schedule updated.");
      if (onUpdated) onUpdated(data.partner);
    } catch (err) {
      console.error(err);
      setMessage(err.message || "Unable to update payout schedule.");
      setSchedule(partner.commission_payout_schedule || "automatic");
    } finally {
      setSaving(false);
    }
  }

  return (
    <div className="settings-card">
      <h3>Payout Rules</h3>

      <div className="row">
        <span>Commission payout schedule</span>
        <select value={schedule} onChange={(event) => saveSchedule(event.target.value)} disabled={saving}>
          {options.map((option) => <option key={option.value} value={option.value}>{option.label}</option>)}
        </select>
      </div>

      <p className="hint">Authorized commissions are released according to your selected payout schedule. All commissions are subject to a 14-day hold after the qualifying client payment.</p>

      {!partner.stripe_connected && <p className="hint warning">Connect Stripe before authorized commissions can be paid out.</p>}
      {message && <small>{message}</small>}
    </div>
  );
}
